import { render, staticRenderFns } from "./CombinedResultAchievementReportWidget.vue?vue&type=template&id=0cf3501e"
import script from "./CombinedResultAchievementReportWidget.vue?vue&type=script&lang=js"
export * from "./CombinedResultAchievementReportWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf3501e')) {
      api.createRecord('0cf3501e', component.options)
    } else {
      api.reload('0cf3501e', component.options)
    }
    module.hot.accept("./CombinedResultAchievementReportWidget.vue?vue&type=template&id=0cf3501e", function () {
      api.rerender('0cf3501e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/ExamReport/CombinedResultAchievementReportWidget.vue"
export default component.exports